// A PDF of a document as it is drawn on the page: the element is captured as an image (html2canvas) and laid on A4 /
// A5 / Letter pages (jsPDF), split across pages when it is taller. Both libraries load only when a PDF is made.
export type Paper = "A4" | "A5" | "Letter";

export async function elementToPdf(el: HTMLElement, paper: Paper = "A4"): Promise<string> {
  const [{ default: html2canvas }, { jsPDF }] = await Promise.all([import("html2canvas"), import("jspdf")]);
  const canvas = await html2canvas(el, { scale: 2, backgroundColor: "#ffffff", useCORS: true, logging: false });
  const pdf = new jsPDF({ unit: "mm", format: paper === "Letter" ? "letter" : paper.toLowerCase(), compress: true });
  const pw = pdf.internal.pageSize.getWidth(), ph = pdf.internal.pageSize.getHeight(), m = paper === "A5" ? 6 : 10;
  const w = pw - 2 * m, pagePx = Math.floor(((ph - 2 * m) / w) * canvas.width);
  for (let y = 0, page = 0; y < canvas.height; y += pagePx, page++) {
    const h = Math.min(pagePx, canvas.height - y);
    const slice = document.createElement("canvas");
    slice.width = canvas.width; slice.height = h;
    slice.getContext("2d")!.drawImage(canvas, 0, y, canvas.width, h, 0, 0, canvas.width, h);
    if (page > 0) pdf.addPage();
    pdf.addImage(slice.toDataURL("image/jpeg", 0.92), "JPEG", m, m, w, (h / canvas.width) * w);
  }
  // base64 without the data: prefix
  return pdf.output("datauristring").split(",")[1];
}

export const pdfName = (title: string, number?: string | null) =>
  `${title}${number ? " " + number : ""}`.replace(/[\\/:*?"<>|]+/g, "-").replace(/\s+/g, " ").trim() + ".pdf";
